<template>
  <div id="home">
    <header>
      <b-navbar toggleable="lg" class="topbar">
      <span class="sidebar-toggle" @click="toggleClass()"><font-awesome-icon class="fa-fw"
                                                                             :icon="['fas', 'bars']"/></span>
        <b-navbar-brand class="mr-0" href="/"><img src='../assets/images/ford-logo.png'
                                                   class="topbar-logo mr-lg-4 mr-md-4" alt="Ford Logo"><span
          class="title-font">Technician Retention Assessment Tool</span></b-navbar-brand>



        <b-navbar-toggle target="nav-collapse" class="float-right">
          <template>
            <font-awesome-icon class="fa-fw" :icon="['fal', 'user-cog']"/>
            <div class="screen"></div>
          </template>
        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav class="mt-1 mt-lg-0">
            <mq-layout mq="xl">
              <b-nav-item-dropdown right>
                <template slot="button-content" :to="{ name: 'ActivityIndex'}" v-if="user.first_name">{{ `${user.first_name} ${user.last_name}` }}</template>
                <!--              <b-dropdown-item :to="{ name: 'Home' }">Privacy Policy</b-dropdown-item>-->
                <!--              <b-dropdown-item :to="{ name: 'Home' }">Terms & Conditions</b-dropdown-item>-->
                <!--              <b-dropdown-item v-b-modal.emailModal>Email a Reminder</b-dropdown-item>-->
                <b-dropdown-item @click="logout">Logout</b-dropdown-item>
              </b-nav-item-dropdown>
            </mq-layout>
            <mq-layout :mq="['sm', 'md', 'lg']">
              <template slot="button-content" :to="{ name: 'ActivityIndex'}" v-if="user.first_name">{{ `${user.first_name} ${user.last_name}` }}</template>
              <span class="mobile-username">{{ `${user.first_name} ${user.last_name}` }}</span>
              <!--            <b-nav-item :to="{ name: 'Home' }">Privacy Policy</b-nav-item>-->
              <!--            <b-nav-item :to="{ name: 'Home' }">Terms & Conditions</b-nav-item>-->
              <!--            <b-nav-item v-b-modal.emailModal>Email a Reminder</b-nav-item>-->
              <b-nav-item @click="logout">Logout</b-nav-item>
            </mq-layout>

          </b-navbar-nav>
        </b-collapse>
      </b-navbar>

      <div class="mx-2 px-1 mb-2 pb-3 mb-2">
        <b-row align-v="center" align-h="start">
          <b-col cols="3">
            <v-select v-if="true" class="dealer-selector ml-auto mt-1 mt-lg-0" :options="paginated" @search="query => search = query" :filterable="false"
                      @open="onOpen"
                      @close="onClose"
                      placeholder="Enter Dealer Name or Code" v-model="selectedDealership">

              <template #list-footer>
                <li ref="load" class="loader" v-show="hasNextPage">
                  Loading more options...
                </li>
              </template>
            </v-select>
            <v-select v-else class="dealer-selector ml-auto mt-1 mt-lg-0" :options="dealers" @search="query => search = query"
                      placeholder="Enter Dealer Name or Code" v-model="selectedDealership"></v-select>
          </b-col>

          <!-- TSOTOOL-275: Hidden due to low activity on Tech Growth Plan
          <b-col cols="3" class="ml-auto techgrowth-link-container">
            <b-link :href="dealershipTechnicianLink" target="_blank" class="techgrowth-link">
              Dealership Technician Growth Plan
            </b-link>
          </b-col>
          -->

          <div class="w-100"></div>

        </b-row>
      </div>


    </header>


    <!-- Main Content of the Page -->
    <div class="main" v-if="ready">
      <div class="left sidebar closed">
        <span class="sidebar-toggle" @click="toggleClass()"><font-awesome-icon class="fa-fw"
                                                                               :icon="['fal', 'long-arrow-left']"/></span>
        <div class="sidebar-item" @click="toggleClass()">
          <router-link exact class="sidebar-link" :to="{ name: 'Background'}">
                        <span class="sidebar-link-text">
                            <font-awesome-icon class="fa-fw" :icon="['fal', 'user-chart']"/>
                            <span>Retention Assessment Background</span>
                        </span>
          </router-link>
        </div>

        <div class="sidebar-item" @click="toggleClass()">
          <router-link exact-path class="sidebar-link" :to="{ name: 'ROICalculator' }">
                        <span class="sidebar-link-text">
                            <font-awesome-icon class="fa-fw" :icon="['fal', 'calculator']"/>
                            <span>ROI Calculator</span>
                        </span>
          </router-link>
        </div>

        <div class="sidebar-item" @click="toggleClass()">
          <router-link class="sidebar-link disabled" :to="{ name: 'Form'}" :disabled="currentDealership === null" :is="currentDealership === null ? 'span' : 'router-link'">
                        <span class="sidebar-link-text">
                            <font-awesome-icon class="fa-fw" :icon="['fal', 'ballot-check']"/>
                            <span>Assessment Form</span>
                        </span>
          </router-link>
        </div>
        <div class="sidebar-item" @click="toggleClass()">
          <router-link class="sidebar-link" :to="{ name: 'Report'}" :disabled="currentDealership === null || currentAssessment.benchmarks === '{}'" :is="currentDealership === null || currentAssessment.benchmarks === '{}' ? 'span' : 'router-link'">
                        <span class="sidebar-link-text">
                            <font-awesome-icon class="fa-fw" :icon="['fal', 'chart-pie']"/>
                            <span>Assessment Report / Retention Priority</span>
                        </span>
          </router-link>
        </div>
        <div class="sidebar-item" @click="toggleClass()">
          <router-link class="sidebar-link" :to="{ name: 'Plan'}" :disabled="currentDealership === null || currentAssessment.priority === null" :is="currentDealership === null || currentAssessment.priority === null ? 'span' : 'router-link'">
                        <span class="sidebar-link-text">
                            <font-awesome-icon class="fa-fw" :icon="['fal', 'star-exclamation']"/>
                            <span>Action Plan</span>
                        </span>
          </router-link>
        </div>
        <div class="sidebar-item" @click="toggleClass()">
          <router-link class="sidebar-link" :to="{ name: 'ReportExport'}">
                        <span class="sidebar-link-text">
                            <font-awesome-icon class="fa-fw" :icon="['fal', 'copy']"/>
                            <span>Report Export & History</span>
                        </span>
          </router-link>
        </div>
        <div class="sidebar-item" @click="toggleClass()">
          <router-link exact-path class="sidebar-link" :to="{ name: 'ReportAnalytics' }">
                        <span class="sidebar-link-text">
                            <font-awesome-icon class="fa-fw" :icon="['fal', 'chart-line']"/>
                            <span>Report Analytics</span>
                        </span>
          </router-link>
        </div>

        <div class="sidebar-item mt-5">
          <img src="../assets/images/5253_SCS Wheel logo redesign_F.png" class="h-100 w-100"/>
        </div>
<!--        <img src='../assets/images/ford-logo.png' class="topbar-logo d-block" alt="Ford Logo"/>-->
      </div>
      <div class="screen" @click="toggleClass()"></div>
      <div class="right">
        <router-view></router-view>
          <div class="footer mb-5">
            <div class="container">

              <span class="float-left text-muted">
                &copy; Ford Motor Company 2021
              </span>
                <span class="float-right text-muted">
                Proprietary and internal use only
              </span>
            </div>
          </div>
      </div>
    </div>

    <b-modal id="emailModal" ref="email-modal" size="xl" title="Email a Reminder" no-stacking>
      <template #modal-header-close>
        <font-awesome-icon class="fa-fw" :icon="['fal', 'times-circle']"/>
      </template>
      <p class="my-4">Do you want to send a reminder to follow up with this person.</p>
      <div role="group">
        <label for="email-live">Email Recipient</label>
        <b-form-input
          id="email-live"
          aria-describedby="input-live-feedback"
          trim
          placeholder="user@example.com"
        ></b-form-input>

        <!-- This will only be shown if the preceding input has an invalid state -->
        <b-form-invalid-feedback id="input-live-feedback">
          Must enter a valid email address
        </b-form-invalid-feedback>

      </div>
      <div class="mt-4" role="group">
        <label for="subject-live">Subject</label>
        <b-form-input
          id="subject-live"
          aria-describedby="input-live-feedback"
          trim
          placeholder="Enter subject here"
        ></b-form-input>

        <!-- This will only be shown if the preceding input has an invalid state -->
        <b-form-invalid-feedback id="input-live-feedback">
          Must fill in subject field
        </b-form-invalid-feedback>

      </div>
      <div class="mt-4 mb-4" role="group">
        <label for="email-content">Content</label>
        <vue-editor id="email-content" class="email-text"></vue-editor>
      </div>
      <template #modal-footer>
        <b-button class="close-btn mr-2" @click="hideEmailModal" pill>Close</b-button>
        <b-button class="success-button" v-b-modal.successModal pill>Send Email</b-button>
      </template>
    </b-modal>

    <b-modal id="successModal" ref="success-modal" size="md">
      <template #modal-header-close>
        <font-awesome-icon class="fa-fw" :icon="['fal', 'times-circle']"/>
      </template>
      <font-awesome-icon class="fa-fw mt-3" :icon="['fal', 'check-circle']"/>
      <p class="mt-4 mb-1">Your reminder has been sent successfully.</p>
      <template #modal-footer>
        <b-button class="success-button" @click="hideSuccessModal" pill>Close</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import OpenIndicator from './OpenIndicator.vue';
import Deselect from './Deselect.vue';
import vSelect from 'vue-select';
import {parseJwt} from "@/services/jwt.service";
import ApiService from "@/services/api.service";
import { mapState, mapMutations } from 'vuex';

vSelect.props.components.default = () => ({OpenIndicator, Deselect});
export default {
  name: "Home",
  data() {
    return {
      ready: false,
      user: {
        first_name: null,
        last_name: null
      },
      limit: 50,
      search: '',
      dealers: [],
      selectedDealership: null,
      observer: null,
      assessment: null,
      get priority() {
        var priority = localStorage.getItem('priority') || null
        if (priority === "null") {
          priority = null
        }
        return priority
      },
      get assessmentObversved() {
        var assessmentObversved = localStorage.getItem('assessmentForm') || null
        if (assessmentObversved === "null") {
          assessmentObversved = null
        }
        return assessmentObversved
      },
      ie: false,
      currentEnvironment: process.env.VUE_APP_ENV,
    }
  },
  components: {
    Calculator: () => import('./Calculator'),
  },
  computed: {
    ...mapState(['currentDealership', 'currentAssessment']),
    dealershipTechnicianLink() {
      if (this.currentEnvironment === 'staging') {
        return 'https://techgrowth.staging.fordtechretention.com';
      } else if (this.currentEnvironment === 'production') {
        return 'https://techgrowth.fordtechretention.com';
      }

      return 'https://techgrowth.qa.fordtechretention.com';
    },
    filtered() {
      // if (this.search.length < 3) {
      //   return [];
      // }
      return this.dealers.filter(dealer => dealer.label.toLowerCase().includes(this.search.toLowerCase()));
    },
    paginated() {
      return this.filtered.slice(0, this.limit);
    },
    hasNextPage() {
      return this.paginated.length < this.filtered.length
    }
  },
  created() {
    this.ieCheck();
    if (!this.ie) {

      this.observer = new IntersectionObserver(this.infiniteScroll);
    }
    this.getCurrentUser();
    this.getDealers();
    this.getAssessment();
    this.ready = true;
  },
  updated() {
    // this.getAssessment();
  },
  methods: {
    ...mapMutations(['setCurrentDealership', 'setCurrentBenchmarks']),
    ieCheck() {
      var ua = window.navigator.userAgent;
      var isIE = /MSIE|Trident/.test(ua);

      if ( isIE ) {
        //IE specific code goes here
        this.ie = true;
      }
    },
    logout() {
      localStorage.removeItem('id_token');
      this.$router.push({ name: 'Home'});
    },
    async infiniteScroll ([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.offsetParent;
        const scrollTop = target.offsetParent.scrollTop;
        this.limit += 10;
        await this.$nextTick();
        ul.scrollTop = scrollTop;
      }
    },
    async onOpen () {
      if (this.hasNextPage) {
        await this.$nextTick();
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect();
    },
    getAssessment() {
      this.assessment = JSON.parse(localStorage.getItem('assessmentForm')) || null;
    },
    getCurrentUser() {
      let jwt = parseJwt();
      console.log(jwt.sub)
      ApiService.get('api/v1/users', jwt.sub)
        .then((data) => {
          this.user.first_name = data.data.first_name
          this.user.last_name = data.data.last_name
          this.user.role = data.data.role
        });
    },
    getDealers() {
      ApiService.query('api/v1/assessments/dealers')
        .then((data) => {

          function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
          }

          var clean = data.data.map(item => {
            item.code = item.pa;
            delete item.pa
            item.label = `#${pad(item.code, 5)} - ${item.name}`;
            item.name = `${item.name} #${item.code}`
            return item;
          })
          this.dealers = clean;
          this.populateDealership();
        });
    },
    populateDealership() {
      this.selectedDealership = this.currentDealership;
    },
    toggleClass() {
      let sidebar = document.querySelector('.sidebar');
      sidebar.classList.toggle('closed');
    },
    hideSuccessModal() {
      this.$refs["success-modal"].hide();
    },
    hideEmailModal() {
      this.$refs["email-modal"].hide();
    },
  },
  watch: {
    selectedDealership(){
      this.setCurrentDealership(this.selectedDealership);
      var current_dealership = JSON.parse(localStorage.getItem('selected_dealership'));
      if (this.selectedDealership === null || JSON.stringify(this.selectedDealership) !== JSON.stringify(current_dealership)) {
        localStorage.removeItem('selected_dealership');
        localStorage.removeItem('priority');
        localStorage.removeItem('assessmentForm');
        localStorage.removeItem('reportCheckboxes');
        this.setCurrentBenchmarks(null);
        if (this.$route.path !== "/") {
          this.$router.push({ name: 'Background'});
        }
      }
      localStorage.setItem('selected_dealership', JSON.stringify(this.selectedDealership));

      if (this.selectedDealership !== null) {
        const params = {
          'query[dealership_eq]': this.selectedDealership.name.replace('\'', ''),
          'query[s]': 'updated_at desc',
          page: 1,
          per_page: 1
        };

        ApiService.query('api/v1/assessments', { params })
          .then((data) => {
            if (data.data && data.data.length > 0) {
              const benchmarks = JSON.parse(data.data[0].benchmarks)

              const i18n = this.$t("assessmentForm");

              let form = {
                "assessmentForm.compensation.c1": [],
                "assessmentForm.compensation.c2": [],
                "assessmentForm.compensation.c3": [],
                "assessmentForm.training.c1": [],
                "assessmentForm.training.c2": [],
                "assessmentForm.training.c3": [],
                "assessmentForm.training.c4": [],
                "assessmentForm.management.c1": [],
                "assessmentForm.management.c2": [],
                "assessmentForm.management.c3": [],
                "assessmentForm.dealerConditions.c1": [],
                "assessmentForm.dealerConditions.c2": [],
                "assessmentForm.dealerConditions.c3": [],
                "assessmentForm.dealerConditions.c4": [],
                "assessmentForm.rewards.c1": [],
                "assessmentForm.rewards.c2": [],
                "assessmentForm.rewards.c3": [],
              }

              if (benchmarks[0].headers[0].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[0].headers[0].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.compensation.c1.q1) form["assessmentForm.compensation.c1"].push("assessmentForm.compensation.c1.q1")
                    if (key.question === i18n.compensation.c1.q2) form["assessmentForm.compensation.c1"].push("assessmentForm.compensation.c1.q2")
                    if (key.question === i18n.compensation.c1.q3) form["assessmentForm.compensation.c1"].push("assessmentForm.compensation.c1.q3")
                  }
                })
              } else form["assessmentForm.compensation.c1"].push("uncheckAll")
              if (benchmarks[0].headers[1].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[0].headers[1].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.compensation.c2.q1) form["assessmentForm.compensation.c2"].push("assessmentForm.compensation.c2.q1")
                    if (key.question === i18n.compensation.c2.q2) form["assessmentForm.compensation.c2"].push("assessmentForm.compensation.c2.q2")
                    if (key.question === i18n.compensation.c2.q3) form["assessmentForm.compensation.c2"].push("assessmentForm.compensation.c2.q3")
                  }
                })
              } else form["assessmentForm.compensation.c2"].push("uncheckAll")
              if (benchmarks[0].headers[2].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[0].headers[2].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.compensation.c3.q1) form["assessmentForm.compensation.c3"].push("assessmentForm.compensation.c3.q1")
                    if (key.question === i18n.compensation.c3.q2) form["assessmentForm.compensation.c3"].push("assessmentForm.compensation.c3.q2")
                    if (key.question === i18n.compensation.c3.q3) form["assessmentForm.compensation.c3"].push("assessmentForm.compensation.c3.q3")
                  }
                })
              } else form["assessmentForm.compensation.c3"].push("uncheckAll")

              if (benchmarks[1].headers[0].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[1].headers[0].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.training.c1.q1) form["assessmentForm.training.c1"].push("assessmentForm.training.c1.q1")
                    if (key.question === i18n.training.c1.q2) form["assessmentForm.training.c1"].push("assessmentForm.training.c1.q2")
                    if (key.question === i18n.training.c1.q3) form["assessmentForm.training.c1"].push("assessmentForm.training.c1.q3")
                  }
                })
              } else form["assessmentForm.training.c1"].push("uncheckAll")
              if (benchmarks[1].headers[1].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[1].headers[1].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.training.c2.q1) form["assessmentForm.training.c2"].push("assessmentForm.training.c2.q1")
                    if (key.question === i18n.training.c2.q2) form["assessmentForm.training.c2"].push("assessmentForm.training.c2.q2")
                    if (key.question === i18n.training.c2.q3) form["assessmentForm.training.c2"].push("assessmentForm.training.c2.q3")
                  }
                })
              } else form["assessmentForm.training.c2"].push("uncheckAll")
              if (benchmarks[1].headers[2].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[1].headers[2].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.training.c3.q1) form["assessmentForm.training.c3"].push("assessmentForm.training.c3.q1")
                    if (key.question === i18n.training.c3.q2) form["assessmentForm.training.c3"].push("assessmentForm.training.c3.q2")
                    if (key.question === i18n.training.c3.q3) form["assessmentForm.training.c3"].push("assessmentForm.training.c3.q3")
                  }
                })
              } else form["assessmentForm.training.c3"].push("uncheckAll")
              if (benchmarks[1].headers[3].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[1].headers[3].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.training.c4.q1) form["assessmentForm.training.c4"].push("assessmentForm.training.c4.q1")
                    if (key.question === i18n.training.c4.q2) form["assessmentForm.training.c4"].push("assessmentForm.training.c4.q2")
                    if (key.question === i18n.training.c4.q3) form["assessmentForm.training.c4"].push("assessmentForm.training.c4.q3")
                  }
                })
              } else form["assessmentForm.training.c4"].push("uncheckAll")

              if (benchmarks[2].headers[0].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[2].headers[0].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.management.c1.q1) form["assessmentForm.management.c1"].push("assessmentForm.management.c1.q1")
                    if (key.question === i18n.management.c1.q2) form["assessmentForm.management.c1"].push("assessmentForm.management.c1.q2")
                    if (key.question === i18n.management.c1.q3) form["assessmentForm.management.c1"].push("assessmentForm.management.c1.q3")
                  }
                })
              } else form["assessmentForm.management.c1"].push("uncheckAll")
              if (benchmarks[2].headers[1].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[2].headers[1].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.management.c2.q1) form["assessmentForm.management.c2"].push("assessmentForm.management.c2.q1")
                    if (key.question === i18n.management.c2.q2) form["assessmentForm.management.c2"].push("assessmentForm.management.c2.q2")
                    if (key.question === i18n.management.c2.q3) form["assessmentForm.management.c2"].push("assessmentForm.management.c2.q3")
                  }
                })
              } else form["assessmentForm.management.c2"].push("uncheckAll")
              if (benchmarks[2].headers[2].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[2].headers[2].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.management.c3.q1) form["assessmentForm.management.c3"].push("assessmentForm.management.c3.q1")
                    if (key.question === i18n.management.c3.q2) form["assessmentForm.management.c3"].push("assessmentForm.management.c3.q2")
                    if (key.question === i18n.management.c3.q3) form["assessmentForm.management.c3"].push("assessmentForm.management.c3.q3")
                  }
                })
              } else form["assessmentForm.management.c3"].push("uncheckAll")

              if (benchmarks[3].headers[0].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[3].headers[0].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.dealerConditions.c1.q1) form["assessmentForm.dealerConditions.c1"].push("assessmentForm.dealerConditions.c1.q1")
                    if (key.question === i18n.dealerConditions.c1.q2) form["assessmentForm.dealerConditions.c1"].push("assessmentForm.dealerConditions.c1.q2")
                    if (key.question === i18n.dealerConditions.c1.q3) form["assessmentForm.dealerConditions.c1"].push("assessmentForm.dealerConditions.c1.q3")
                  }
                })
              } else form["assessmentForm.dealerConditions.c1"].push("uncheckAll")
              if (benchmarks[3].headers[1].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[3].headers[1].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.dealerConditions.c2.q1) form["assessmentForm.dealerConditions.c2"].push("assessmentForm.dealerConditions.c2.q1")
                    if (key.question === i18n.dealerConditions.c2.q2) form["assessmentForm.dealerConditions.c2"].push("assessmentForm.dealerConditions.c2.q2")
                    if (key.question === i18n.dealerConditions.c2.q3) form["assessmentForm.dealerConditions.c2"].push("assessmentForm.dealerConditions.c2.q3")
                  }
                })
              } else form["assessmentForm.dealerConditions.c2"].push("uncheckAll")
              if (benchmarks[3].headers[2].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[3].headers[2].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.dealerConditions.c3.q1) form["assessmentForm.dealerConditions.c3"].push("assessmentForm.dealerConditions.c3.q1")
                    if (key.question === i18n.dealerConditions.c3.q2) form["assessmentForm.dealerConditions.c3"].push("assessmentForm.dealerConditions.c3.q2")
                    if (key.question === i18n.dealerConditions.c3.q3) form["assessmentForm.dealerConditions.c3"].push("assessmentForm.dealerConditions.c3.q3")
                  }
                })
              } else form["assessmentForm.dealerConditions.c3"].push("uncheckAll")
              if (benchmarks[3].headers[3].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[3].headers[3].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.dealerConditions.c4.q1) form["assessmentForm.dealerConditions.c4"].push("assessmentForm.dealerConditions.c4.q1")
                    if (key.question === i18n.dealerConditions.c4.q2) form["assessmentForm.dealerConditions.c4"].push("assessmentForm.dealerConditions.c4.q2")
                    if (key.question === i18n.dealerConditions.c4.q3) form["assessmentForm.dealerConditions.c4"].push("assessmentForm.dealerConditions.c4.q3")
                  }
                })
              } else form["assessmentForm.dealerConditions.c4"].push("uncheckAll")

              if (benchmarks[4].headers[0].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[4].headers[0].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.rewards.c1.q1) form["assessmentForm.rewards.c1"].push("assessmentForm.rewards.c1.q1")
                    if (key.question === i18n.rewards.c1.q2) form["assessmentForm.rewards.c1"].push("assessmentForm.rewards.c1.q2")
                    if (key.question === i18n.rewards.c1.q3) form["assessmentForm.rewards.c1"].push("assessmentForm.rewards.c1.q3")
                  }
                })
              } else form["assessmentForm.rewards.c1"].push("uncheckAll")
              if (benchmarks[4].headers[1].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[4].headers[1].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.rewards.c2.q1) form["assessmentForm.rewards.c2"].push("assessmentForm.rewards.c2.q1")
                    if (key.question === i18n.rewards.c2.q2) form["assessmentForm.rewards.c2"].push("assessmentForm.rewards.c2.q2")
                    if (key.question === i18n.rewards.c2.q3) form["assessmentForm.rewards.c2"].push("assessmentForm.rewards.c2.q3")
                  }
                })
              } else form["assessmentForm.rewards.c2"].push("uncheckAll")
              if (benchmarks[4].headers[2].checkboxes.filter((data) => data.checked === true).length > 0) {
                benchmarks[4].headers[2].checkboxes.forEach((key) => {
                  if (key.checked) {
                    if (key.question === i18n.rewards.c3.q1) form["assessmentForm.rewards.c3"].push("assessmentForm.rewards.c3.q1")
                    if (key.question === i18n.rewards.c3.q2) form["assessmentForm.rewards.c3"].push("assessmentForm.rewards.c3.q2")
                    if (key.question === i18n.rewards.c3.q3) form["assessmentForm.rewards.c3"].push("assessmentForm.rewards.c3.q3")
                  }
                })
              } else form["assessmentForm.rewards.c3"].push("uncheckAll")

              // localStorage.setItem('assessmentForm', JSON.stringify(form));
              this.$parent.loadCurrentBenchmarks();
            }
          });
      }


    }
  }
}
</script>

<style lang="scss">
  #trtcalc {
    .modal-content {
      max-width: 817px;
      width: 100%;
      margin: 0 auto;
      /*padding: 20px 65px;*/
      height: 95vh;
      /*overflow: scroll;*/

      /*@media (max-width: 767px) {*/
      /*  padding: 20px 60px;*/
      /*}*/

      .form-inner {
        padding: 20px 65px;
        @media (max-width: 767px) {
          padding: 10px;
        }

        h1 {
          color: $fordBlueDark;
          font-family: FordAntenna-Medium;
          font-size: 24px;
          font-weight: 500;
          height: 44px;
          letter-spacing: 0px;
          line-height: 29px;
        }
      }

      .modal-body {
        height: 75vh;
        overflow-y: scroll;

        label {
          color: $fordBlueDark;
          text-transform: capitalize;
          font-size: 13px;
          letter-spacing: 0;
          margin-bottom: 5px;
        }
      }
    }

    .modal-header {
      background: white;
      .close {
        font-size: 32px;
        color: #102b4e;
      }
    }

    .modal-footer {
      border-top: 1px solid black;
      .footer-btns {
        width: 100%;
        padding-left: 50px;
        padding-right: 50px;
        @media (max-width: 767px) {
          padding: 20px 60px;
        }
      }
    }
  }
</style>

<style lang="scss" scoped>

// Layout Styles
.main {
  display: flex;
  height: calc(100% - 62px);
  @media (min-width: 992px) {
    height: calc(100% - 88px);
  }
  @media (max-width: 1046px) {
    .closed ~ .screen {
      display: none;
      opacity: 0;
      visibility: hidden;
    }
    .screen {
      display: block;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background: #000;
      opacity: 25%;
      visibility: visible;
      z-index: 99;
    }
  }
}

#nav-collapse {
  margin-left: auto;
}

.sidebar {
  background-color: $lightGrey;
  width: 100%;
  padding-top: 10px;
  transition: margin-left 0.25s;
  @media (max-width: 1046px) {
    position: fixed;
    padding-top: 98px;
    z-index: 99999;
    top: 0;
    left: 0;
    &.closed {
      margin-left: -250px;

      & + .sidebar-toggle {
        left: 0;
      }
    }
  }

  .sidebar-toggle {
    position: absolute;
    top: 0;
    left: 200px;

    svg {
      font-size: 24px;
    }
  }
}

.sidebar-toggle {
  display: none;
  cursor: pointer;
  padding: 12px 6px;
  @media (max-width: 1046px) {
    display: block;
    z-index: 999;
  }

  svg {
    font-size: 20px;
  }
}

.left {
  max-width: 250px;
  height: 100%;
  overflow-y: auto;
}

.right {
  width: 100%;
  height: 100%;
  background: $backgroundGrey;
  overflow-y: auto;
}

[disabled="disabled"] {
  cursor: not-allowed;
}

#home {
  height: 100%;

  // Topbar Styles
  /deep/ .topbar {
    /*height: 10vh;*/
    @media (min-width: 992px) {
      height: 88px;
    }
    @media (max-width: 449px) {
      padding: 4px 8px;
    }

    .topbar-logo {
      max-width: 94px;
      max-height: 33px;
      @media (max-width: 430px) {
        display: none;
      }
    }

    .title-font {
      font-family: FordAntennaCond-Light, sans-serif;
      font-size: 1.5rem;
      @media (max-width: 1100px) {
        font-size: 1.2rem;
      }
      @media (max-width: 1046px) {
        display: none;
      }
    }

    .navbar-collapse {
      text-align: right;
      @media (min-width: 992px) {
        max-width: 230px;
        margin-right: 20px;
      }

      .mobile-username {
        padding-right: 1rem;
      }
    }

    /deep/ .navbar-toggler {
      border: 0;

      svg {
        width: 25px;
        height: 25px;

        path {
          color: $textBlue;
        }
      }

      @media (max-width: 350px) {
        padding-right: 0;
      }

      &.collapsed {
        .screen {
          display: none;
        }
      }

      &.not-collapsed {
        .screen {
          display: block;
          position: absolute;
          top: 100%;
          left: 0;
          width: 100%;
          height: 100vh;
          background: black;
          opacity: 25%;
          z-index: 99;
        }
      }
    }

    // User Dropdown Menu
    /deep/ .dropdown {
      text-align: right;
      @media (min-width: 992px) {
        width: 230px;
        margin-left: 30px;
      }
      color: #102b4e;

      .dropdown-toggle {
        border: 1px solid #fff;
        border-bottom: 0;
        border-radius: 0.25rem;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        background: #fff;
        padding: 1rem 1.5rem !important;
        color: $fordBlue;

        &:after {
          vertical-align: baseline;
          border-top: 0.35em solid;
          border-right: 0.35em solid transparent;
          border-bottom: 0;
          border-left: 0.35em solid transparent;
        }
      }

      &.show {
        .nav-link[aria-expanded="true"] {
          border-color: $darkGrey;
          box-shadow: 0 15px 15px 0 rgba(0, 0, 0, 0.3);

          &:after {
            border-top: 0;
            border-right: 0.35em solid transparent;
            border-bottom: 0.35em solid;
            border-left: 0.35em solid transparent;
          }
        }

        .dropdown-menu {
          width: inherit;
          box-shadow: 0 15px 15px 0 rgba(0, 0, 0, 0.3);
          margin-top: 0;
          border-top: 0;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
          border-color: $darkGrey;
          padding: 0 0 0.5rem;

          li:not(:last-of-type) {
            margin-bottom: 15px;
          }

          .dropdown-item {
            padding: 0.5rem 1rem;
            color: $fordBlue;
            font-size: 16px;

            &:hover {
              background-color: $lightGrey;
            }
          }
        }
      }

    }

    // Mobile Right Menu
    .navbar-nav {
      .nav-link {
        text-align: right;
        color: $fordBlue;
        font-size: 16px;
        padding-right: 1rem;

        &:hover {
          background-color: $lightGrey;
        }
      }
    }
  }

  // Dealer Selector Styles
  .dealer-selector {
    @extend .custom-dropdown;
  }

  // Sidebar Styles
  .sidebar-item {
    text-align: left;

    .sidebar-link {
      display: flex;
      justify-content: center;
      align-content: center;
      flex-direction: column;
      height: 70px;
      padding: 5px 10px;
      border-left: 3px solid transparent;
      color: $textBlue;

      .sidebar-link-text {
        display: flex;
        align-items: center;

        svg {
          margin-right: 10px;
          font-size: 21px;
        }

        span {
          font-family: FordAntennaCond-Regular, sans-serif;
          //font-size: 14px !important;
          font-size: 1rem;
          color: $textBlue;
        }
      }

      &.router-link-exact-active, &.router-link-active {
        background: $backgroundGrey;
        border-color: $linkActive;
        color: $linkActive;

        .sidebar-link-text {
          span {
            color: $linkActive;
          }

          svg path {
            fill: $linkActive;
          }
        }

      }
    }
  }

  .techgrowth-link-container {
    margin-right: 90px;

    .techgrowth-link {
      font-family: "FordAntennaCond-Regular", sans-serif;
      color: $fordBlue;
      font-size: 18px;
      text-decoration: underline;
      letter-spacing: 1px;
    }
  }
}


</style>




